import { Phone, MessageCircle, Mail, MapPin, Instagram, Facebook, Globe } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "../data/content";
import { scrollToId } from "../lib/scroll";

export const Footer = () => (
  <footer data-testid="footer" className="bg-royal-deep text-ivory grain relative">
    <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 md:pt-24 pb-10 relative">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img
            src="/brand/kp-logo.png"
            alt="Jeweller Kalika Prasad"
            data-testid="footer-logo"
            className="h-16 w-auto"
          />
          <p className="mt-3 font-serif italic text-lg text-gold-light/80">{BUSINESS.tagline}</p>
          <p className="mt-5 text-sm font-light text-ivory/55 leading-relaxed max-w-sm">
            A trusted jewellery showroom in Howrah, West Bengal — BIS hallmarked gold, diamond, silver and bridal jewellery with assured purity and transparent pricing.
          </p>
          <div className="mt-7 flex items-center gap-3">
            <a data-testid="footer-instagram-link" href={BUSINESS.instagramUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-10 h-10 border border-ivory/20 rounded-full flex items-center justify-center text-ivory/70 hover:text-gold hover:border-gold/60 transition-colors duration-300">
              <Instagram size={16} strokeWidth={1.4} />
            </a>
            <a data-testid="footer-facebook-link" href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 border border-ivory/20 rounded-full flex items-center justify-center text-ivory/70 hover:text-gold hover:border-gold/60 transition-colors duration-300">
              <Facebook size={16} strokeWidth={1.4} />
            </a>
            <a data-testid="footer-google-link" href={BUSINESS.reviewsUrl} target="_blank" rel="noopener noreferrer" aria-label="Google" className="w-10 h-10 border border-ivory/20 rounded-full flex items-center justify-center text-ivory/70 hover:text-gold hover:border-gold/60 transition-colors duration-300">
              <Globe size={16} strokeWidth={1.4} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-[11px] tracking-[0.3em] uppercase text-gold font-medium mb-6">Quick Links</p>
          <ul className="grid grid-cols-2 md:grid-cols-1 gap-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="gold-underline text-sm font-light text-ivory/65 hover:text-ivory transition-colors duration-300"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-[11px] tracking-[0.3em] uppercase text-gold font-medium mb-6">Contact</p>
          <ul className="space-y-4 text-sm font-light text-ivory/65">
            <li className="flex items-start gap-3">
              <Phone size={15} strokeWidth={1.4} className="text-gold mt-0.5 shrink-0" />
              <span data-testid="footer-phone" className="space-y-1">
                {BUSINESS.phones.map((p) => (
                  <a key={p.href} href={p.href} className="block hover:text-ivory transition-colors duration-300">{p.display}</a>
                ))}
              </span>
            </li>
            <li className="flex items-start gap-3">
              <MessageCircle size={15} strokeWidth={1.4} className="text-gold mt-0.5 shrink-0" />
              <a data-testid="footer-whatsapp" href={BUSINESS.whatsappHref} target="_blank" rel="noopener noreferrer" className="hover:text-ivory transition-colors duration-300">{BUSINESS.whatsappDisplay}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={15} strokeWidth={1.4} className="text-gold mt-0.5 shrink-0" />
              <span data-testid="footer-email">{BUSINESS.email}</span>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={15} strokeWidth={1.4} className="text-gold mt-0.5 shrink-0" />
              <span data-testid="footer-address">{BUSINESS.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-7 border-t border-ivory/10 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-xs font-light text-ivory/45">© 2026 Jeweller Kalika Prasad. All Rights Reserved.</p>
        <p className="text-xs font-light text-ivory/35 tracking-wide">Purity You Trust. Designs You Love.</p>
      </div>
    </div>
  </footer>
);
